import { render, staticRenderFns } from "./TherapyChoiceBox.vue?vue&type=template&id=4f4129f4"
import script from "./TherapyChoiceBox.vue?vue&type=script&lang=js"
export * from "./TherapyChoiceBox.vue?vue&type=script&lang=js"
import style0 from "./TherapyChoiceBox.vue?vue&type=style&index=0&id=4f4129f4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports